module.exports = __webpack_public_path__ + "img/favicon.8ef31824.png";